import { render, staticRenderFns } from "./upload-conversions.vue?vue&type=template&id=5150dcc6&scoped=true&"
import script from "./upload-conversions.vue?vue&type=script&lang=ts&"
export * from "./upload-conversions.vue?vue&type=script&lang=ts&"
import style0 from "./upload-conversions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./upload-conversions.vue?vue&type=style&index=1&id=5150dcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150dcc6",
  null
  
)

export default component.exports